module.exports = __webpack_public_path__ + "img/s3-5-ja.188acbd2.jpg";